<div class="avatar-container">
  <div
    class="avatar"
    [ngClass]="{
      'avatar-large': avatarSize === 'large',
      'avatar-small': avatarSize === 'small',
      'avatar-mid': avatarSize === 'mid'
    }"
    [style.border]="borderStyle"
    [style.border-color]="borderColor"
    [style.backgroundImage]="'url(&quot;' + backgroundImg + '&quot;)'"
    [style.backgroundSize]="'cover'"
    [style.backgroundPosition]="'center'"
  ></div>
  <mat-icon
    *ngIf="starRate"
    class="icon-rate"
    [style.color]="iconColor"
    [style.background-color]="iconBackgroundColor"
    >star_rate</mat-icon
  >
  <span style="font-weight: bold" class="mt-2" *ngIf="name">{{ name }}</span>
  <span style="font-weight: normal" class="mt-2" *ngIf="name">{{
    profit
  }}</span>
</div>
